import { TranslationType } from "../types";
import { dashboard } from "./ar/dashboard";
import { landing } from "./ar/landing";
import { story } from "./ar/story";
import { common } from "./ar/common";
import { settings } from "./ar/settings"; 
import { auth } from "./ar/auth";
import { navigation } from "./ar/navigation";
import { profile } from "./ar/profile";
import { errors } from "./ar/errors";

export const ar: TranslationType = {
  ...dashboard,
  ...landing,
  ...story,
  ...common,
  ...settings,
  ...auth,
  ...navigation,
  ...profile,
  ...errors
};
